class HeroSlider extends BaseClass {
    constructor(i, items, nav) {
        super(i);
        this.wrap = i;
        this.items = items;
        this.nav = nav;

        this.buildSlider();
    }

    buildSlider() {

        const options = {
            navContainer: this.nav,
            controls: false,
            container: this.items,
            autoplay: true,
            speed: 500,
            autoplayTimeout: 5000,
            autoplayButtonOutput: false,
            mode: "gallery"
        };

        const heroSliderObject = tns(options);
        this.wrap.heroSliderFunc = heroSliderObject;

    }

}

document.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll('[data-hero-slider]').forEach(i => {

        let theHeroSlider = new HeroSlider(i,
            i.querySelector('[data-items]'),
            i.querySelector('[data-nav]')
        );
        i.heroSliderFunc = theHeroSlider;

    })
});